Shopware.Component.register('sw-entity-purchase-button', () => import('./component/verign-dv-accessibility-sw6/sw-entity-purchase-button'));